/* eslint-disable no-empty-pattern */
import React, { useEffect, useState, useRef } from "react";
import {
  dashboard_invoice_approve,
  dashboard_invoice_green_tick,
  dashboard_invoice_order_date,
  dashboard_invoice_order_history,
  // dashboard_invoice_payment_done,
  // dashboard_logo_merchant,
  // calender_icon,
  // info_details_sample_car,
  merchant_dashboard_location_icon,
  pdf,
  manage_my_info_edit_logo,
} from "../../../assets/images";
import styled from "styled-components";
// import { MerchantInvoiceApprove } from "../../../types";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../../services/apiConfig";
import { useForm } from "react-hook-form";
import ErrorModal from "../../ErrorModal";
// import SuccessModal from "../../SuccessModal";
import ConfirmationModal from "../../ConfirmationModal";
import { useLocation, useNavigate } from "react-router-dom";
import ImagePopupModal from "../ImagePopupModal";
import {
  // Modal,
  // ModalHeader,
  // ModalBody,
  // Button,
  Carousel,
} from "react-bootstrap";
import CustomInput from "../../CustomInput";
import AuthRules from "../../../rules/AuthRules";
import { toast } from "react-toastify";
// import DateTimeComponent from "../../DateTimeComponent";
import CustomCheckBox from "../../customCheckbox";
// import DatePicker from "react-datepicker";
import rules from "../../../rules";
import {
  // ChevronDown,
  // ChevronUp,
  // PencilSquare,
  Trash,
} from "react-bootstrap-icons";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from "../../../utils/messages";

//import { toast } from "react-toastify";

const AcceptedorderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const OrderId = new URLSearchParams(location.search).get("OrderId");
  //const OrderId = state && state.OrderId;
  console.log("new", OrderId);
  const { data: invoiceDetails } = useQuery({
    queryKey: ["invoiceDetails", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.ORDER_DETAILS}/${OrderId}/details`,
        {
          headers: {
            location: "0,0",
            language: "english",
          },
        }
      );
      return response.data;
    },
  });
  const { data: commentMessage } = useQuery({
    queryKey: ["commentMessage", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.GET_COMMENTS}/${OrderId}`
      );
      console.log("commentMessagestatuss", commentMessage);
      return response.data;
    },
  });

  // const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  // const [errorMessage, setErrorMessage] = useState<string>("");
  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] =
    useState(false);

  const [acceptConfirmationMessage, setAcceptConfirmationMessage] =
    useState("");

  // const [isSuccess, setIsSuccess] = useState(false);
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //const [selectedSlot, setSelectedSlot] = useState("9-1");
  // const [selectedSlot, setSelectedSlot] = useState("");
  const [plateNumber, setPlateNumber] = useState("");
  const [deliveredFuel, setDeliveredFuel] = useState("");
  const [deliveredMileage, setDeliveredMileage] = useState("");
  const [plateNumberError, setPlateNumberError] = useState("");
  const [comments, setComments] = useState("");
  const [deliveryBoyName, setDeliveryBoyName] = useState("");
  const [deliveryBoyPhone, setDeliveryBoyPhone] = useState("");

  const {
    control,
    formState: { },
    // setValue,
    // getValues,
    // trigger,
  } = useForm({ mode: "onChange" });

  //------------------------------------------------------------------------

  const handlePlateNumberChange = (value: React.SetStateAction<string>) => {
    setPlateNumber(value);
    setPlateNumberError("");
  };
  const handleFuelNumberChange = (value: React.SetStateAction<string>) => {
    if (value === deliveredFuel) {
      setDeliveredFuel("");
    } else {
      setDeliveredFuel(value);
    }
  };
  const handleMileageNumberChange = (value: React.SetStateAction<string>) => {
    setDeliveredMileage(value);
  };

  const handleDeliveryBoyNumberChange = (
    value: React.SetStateAction<string>
  ) => {
    setDeliveryBoyPhone(value);
  };

  const handleDeliveryBoyNameChange = (value: React.SetStateAction<string>) => {
    setDeliveryBoyName(value);
  };

  //--------------------------------------------------------------------------

  const handleOpenConfirmationModal = (message: string) => {
    setAcceptConfirmationMessage(message);
    setShowAcceptConfirmationModal(true);
  };

  const handleSubmit = () => {
    handleOpenConfirmationModal("Delivery Completed?");
  };

  const handleApproval = useMutation({
    mutationFn: () =>
      axiosInstance.put(
        `${API_URL.APPROVE_REJECT}/${OrderId}`,
        {
          order_status: "DELIVERED",
          check_list_image_urls: previousImages,
          plate_number: plateNumber,
          delivery_date: dateTime + ":00",
          delivered_millage: deliveredMileage,
          delivered_fuel: deliveredFuel,
          // delivery_start_time: "",
          // delivery_end_time: "",
          free_upgrade_by_customer: isChecked,
          // free_upgrade_by_merchant: false,
          merchant_comment: comments,
          delivery_boy_details: {
            firstName: deliveryBoyName,
            phoneNumber: deliveryBoyPhone,
          },
        },
        {
          headers: {
            location: "o,o",
            language: "english",
          },
        }
      ),
    onSuccess: (successResponse) => {
      console.log("successResponse", successResponse);

      navigate("/merchant/approvedorders");
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        // setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      }
    },
  });

  const formatDate = (isoDate: any) => {
    if (!isoDate) return "N/A";

    const date = new Date(isoDate);
    // Check if date is invalid
    if (isNaN(date.getTime())) return "N/A";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const [showImagePopupModal, setShowImagePopupModal] = useState(false);
  // const [selectedImage, setSelectedImage] = useState("");
  // const handleimagepopover = () => {
  //   setShowImagePopupModal(true);
  // };

  // const handleClose = () => {
  //   setLoadModal(false);
  // };

  // const [loadModal, setLoadModal] = useState(false);
  const [imageSource, setImageSource] = useState("");
  const fetchAndRenderDocs = (
    docsObject: Record<string, any> | undefined,
    prefix: string
  ) => {
    if (!docsObject) return;

    const matchedDocs = Object.keys(docsObject).filter((key) =>
      key.startsWith(prefix)
    );

    matchedDocs.forEach((docKey) => {
      const documentId = docsObject[docKey];
      if (documentId === undefined || documentId === null) {
        console.warn(`Document ID for ${docKey} is null or undefined`);
        return;
      }

      axiosInstance
        .get(`${API_URL.CUSTOMER_DOCUMENTS}/${documentId}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          if (!response || !response.data) {
            console.error(`Failed to fetch document for ${docKey}`);
            return;
          }

          const contentType = String(response.headers["content-type"] || "");
          const isPdf = contentType === "application/pdf";
          const isImage = contentType.startsWith("image/");

          if (isPdf) {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const objectUrl = URL.createObjectURL(blob);

            const downloadLink = document.getElementById(
              `${docKey}DownloadLink`
            ) as HTMLAnchorElement;
            if (downloadLink) {
              downloadLink.href = objectUrl;
              downloadLink.style.display = "block";
              downloadLink.download = `${docKey}.pdf`;
            }

            const imageElement = document.getElementById(
              `${docKey}_IMAGE`
            ) as HTMLImageElement;
            if (imageElement) {
              imageElement.src = "/path/to/pdf-icon.png"; // replace with your static pdf icon
            }
          } else if (isImage) {
            const blob = new Blob([response.data], { type: contentType });
            const imageUrl = URL.createObjectURL(blob);

            const imageElement = document.getElementById(
              `${docKey}_IMAGE`
            ) as HTMLImageElement;
            if (imageElement) {
              imageElement.src = imageUrl;
              imageElement.onclick = () => {
                setImageSource(imageUrl);
                setShowImagePopupModal(true);
              };
            }

            const imageSizeKB = response.data.byteLength / 1000;
            console.log(`${docKey} Image Size:`, imageSizeKB, "KB");
          }
        })
        .catch((error) => {
          console.error(`Error fetching ${docKey}:`, error);
        });
    });
  };

  useEffect(() => {
    if (invoiceDetails?.customer_details) {
      const { customerDocs, customerAdditionalDocs } =
        invoiceDetails.customer_details;

      // 🔹 Main Docs
      fetchAndRenderDocs(customerDocs, "EMIRITIES");
      fetchAndRenderDocs(customerDocs, "LICENSE");
      fetchAndRenderDocs(customerDocs, "VisitVisa");

      // 🔹 Additional Docs
      fetchAndRenderDocs(customerAdditionalDocs, "EMIRITIES-ADD");
      fetchAndRenderDocs(customerAdditionalDocs, "LICENSE-ADD");
      fetchAndRenderDocs(customerAdditionalDocs, "EMIRITIES1-ADD");
      fetchAndRenderDocs(customerAdditionalDocs, "LICENSE1-ADD");
    }
  }, [invoiceDetails]);

  // const [dropOffDate, setDropOffDate] = useState<string>("");
  // const [pickupDate, setPickupDate] = useState<string>("");

  // const handleDropOffDateChange = (date: string) => {
  //   if (new Date(date) < new Date(pickupDate)) {
  //     setDropOffDate(pickupDate);
  //   } else {
  //     setDropOffDate(date);
  //   }
  // };
  const [isChecked, setChecked] = useState(false);
  const handleCheckBoxChange = () => {
    setChecked(!isChecked);
  };

  // const [selectedDropTime, setSelectedDropTime] = useState("");

  // const handleDropOffTimeChange = (newTime: any) => {
  //   console.log("Selected time:", newTime);
  //   setSelectedDropTime(newTime);
  // };

  const [dateTime, setDateTime] = useState("");
  const [minDateTime, setMinDateTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const isoString = now.toISOString().substring(0, 16);
    setMinDateTime(isoString);
  }, []);

  const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDateTime(event.target.value);
  };

  const handleCommentsChange = (event: any) => {
    setComments(event.target.value);
  };

  //----------------------------------------------------------------------------------------

  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [previousImages, setpreviousImages] = useState<string[]>([]);
  const [vdrUploaded, setVdrUploaded] = useState(false);
  const [rentalAgreementUploaded, setRentalAgreementUploaded] = useState(false);
  const [vdrUploadedImages, setVdrUploadedImages] = useState<string[]>([]);
  const [rentalAgreementUploadedImages, setRentalAgreementUploadedImages] =
    useState<string[]>([]);

  const vdrInputRef = useRef<HTMLInputElement>(null);
  const rentalAgreementInputRef = useRef<HTMLInputElement>(null);

  const openFileInput = (type: any) => {
    if (type === "vdr") {
      vdrInputRef?.current?.click();
    } else if (type === "rentalAgreement") {
      rentalAgreementInputRef?.current?.click();
    }
  };

  // const handleUploadDeleteImage = (index: any, type: any) => {
  //   if (type === "vdr") {
  //     setVdrUploadedImages((prevImages) =>
  //       prevImages.filter((_, i) => i !== index)
  //     );
  //   } else if (type === "rentalAgreement") {
  //     setRentalAgreementUploadedImages((prevImages) =>
  //       prevImages.filter((_, i) => i !== index)
  //     );
  //   }
  // };

  const handleUploadDeleteImage = (index: any, type: any) => {
    if (type === "vdr") {
      setVdrUploadedImages((prevImages) =>
        prevImages.filter((_, i) => i !== index)
      );
      const updatedPreviousImages = previousImages.filter(
        (_, i) => i !== index
      );
      setpreviousImages(updatedPreviousImages);
      const updatedUploadedImages = uploadedImages.filter(
        (_, i) => i !== index
      );
      setUploadedImages(updatedUploadedImages);
    } else if (type === "rentalAgreement") {
      setRentalAgreementUploadedImages((prevImages) =>
        prevImages.filter((_, i) => i !== index)
      );
      const updatedPreviousImages = previousImages.filter(
        (_, i) => i !== index
      );
      setpreviousImages(updatedPreviousImages);
      const updatedUploadedImages = uploadedImages.filter(
        (_, i) => i !== index
      );
      setUploadedImages(updatedUploadedImages);
    }
  };

  const handleImageUpload = async (
    files: FileList | null,
    type: "vdr" | "rentalAgreement"
  ) => {
    if (files) {
      try {
        const promises = [];
        const uploadedFileURLs: any[] = [];
        for (const file of Array.from(files)) {
          const formData = new FormData();
          formData.append("product_image", file);

          const response = await axiosInstance.post(
            API_URL.PRODUCT_IMAGE_UPLOAD,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          uploadedFileURLs.push(response.data);

          promises.push(response);
        }
        // Wait for all uploads to complete
        await Promise.all(promises);

        setpreviousImages((prevImages) => [...prevImages, ...uploadedFileURLs]);
        setUploadedImages((prevUploadedImages) => [
          ...prevUploadedImages,
          ...uploadedFileURLs,
        ]);
        toast.success(SUCCESS_MESSAGES.UPLOAD_SUCCESS);
        if (type === "vdr") {
          setVdrUploadedImages((prevImages) => [
            ...prevImages,
            ...uploadedFileURLs,
          ]);
          setVdrUploaded(true);
        } else if (type === "rentalAgreement") {
          setRentalAgreementUploadedImages((prevImages) => [
            ...prevImages,
            ...uploadedFileURLs,
          ]);
          setRentalAgreementUploaded(true);
        }
        const fileInputRef =
          type === "vdr" ? vdrInputRef : rentalAgreementInputRef;
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } catch (error) {
        toast.error(ERROR_MESSAGES.FAILED_TRY_AGAIN);
        console.error("Error uploading images:", error);
      }
    }
  };

  const formatTime = (dateTimeString: string) => {
    const date = new Date(dateTimeString);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });
  };

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files) {
  //     handleImageUpload(e.target.files);
  //   }
  // };
  //-----------------------------------------------------------------------------------------

  const [showRejectConfirmationModal, setShowRejectConfirmationModal] =
    useState(false);

  const [rejectConfirmationMessage, setRejectConfirmationMessage] =
    useState("");

  const handleOpenRejectConfirmationModal = (message: string) => {
    setRejectConfirmationMessage(message);
    setShowRejectConfirmationModal(true);
  };

  const handleReject = () => {
    handleOpenRejectConfirmationModal("Are you sure you want to cancel?");
  };

  const handleRejection = useMutation({
    mutationFn: () =>
      axiosInstance.put(
        `${API_URL.APPROVE_REJECT}/${OrderId}`,
        {
          order_status: "CANCELLED",
          cancel_reason: comments,
        },
        {
          headers: {
            location: "o,o",
            language: "english",
          },
        }
      ),
    onSuccess: (successResponse) => {
      console.log("successResponse", successResponse);

      navigate("/merchant/approvedorders");
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        // setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      }
    },
  });

  const refpopup = useRef(null);

  const popoverHoverFocus = (
    <Popover id="popover-trigger-hover-focus" className="popover-custom-edit">
      <Popover.Body className="d-flex align-items-center">
        <span className="invoice-div-data text-light">
          Edited by Kirkos backoffice
        </span>
      </Popover.Body>
    </Popover>
  );

  const FuelBar = styled.div`
    display: flex;
    gap: 3px;
    align-items: center;
    padding: 8px;
    background: #000000;
    border-radius: 8px;
    width: fit-content;

    .fuel-segment {
      width: 12px;
      height: 25px;
      border-radius: 4px;
      background: #333333;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 0;
        background: #f0b64f;
        border-radius: 4px;
        transition: height 0.3s ease;
      }

      &.active {
        background: #262626;

        &:before {
          height: 100%;
        }
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(240, 182, 79, 0.2);

        &:not(.active) {
          background: #404040;
        }
      }
    }

    .fuel-label {
      margin-left: 12px;
      font-size: 14px;
      color: #ffffff;
      min-width: 80px;
    }
  `;

  return (
    <div className="row">
      <div className="col-md-12 text-start div-bg-invoice-details ">
        <div className="card card-bg-invoice-details" ref={refpopup}>
          <div className="card-body px-5">
            <div className="row   pb-3">
              <div className="col-md-6 pt-4">
                <table className="invoice-table-width">
                  <tr className="invoice-table-tr-first">
                    <td className="invoice-table-td">Purchase order #</td>
                    <td>Order Created At</td>
                  </tr>
                  <tr>
                    <td className="invoice-text-yellow">
                      {invoiceDetails?.orderId}
                    </td>
                    <td>{formatDate(invoiceDetails?.createdAt)}</td>
                  </tr>
                </table>
                <div className="col-md-12 pt-3">
                  <div className="col-md-6 pt-2 pb-2">
                    <Carousel className="managemycarlist" controls={false}>
                      {invoiceDetails?.products?.[0]?.productImageUrls?.map(
                        (imageUrl: any, index: number) => (
                          <Carousel.Item
                            className="image-managemycar-height"
                            key={index}
                          >
                            <img
                              className="img-merchant-managecar"
                              src={imageUrl}
                              alt={`Product Image ${index + 1}`}
                            />
                          </Carousel.Item>
                        )
                      )}
                    </Carousel>
                  </div>
                  {/* <div className="invoice-text-yellow d-flex align-items-center"> */}
                  <div
                    className={`invoice-text-yellow d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.productId
                      ? "text-danger"
                      : ""
                      }`}
                  >
                    {invoiceDetails?.products[0]?.productName}
                    {invoiceDetails?.modified_field_flags?.productId && (
                      <OverlayTrigger
                        container={refpopup}
                        trigger={["hover"]}
                        placement="top"
                        overlay={popoverHoverFocus}
                      >
                        <div className="ps-2">
                          <img
                            src={manage_my_info_edit_logo}
                            alt="Edit"
                            width="18"
                          />
                        </div>
                      </OverlayTrigger>
                    )}
                  </div>
                </div>

                <div
                  className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                    ?.delivery_location
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Location
                  {invoiceDetails?.modified_field_flags?.delivery_location && (
                    <OverlayTrigger
                      container={refpopup}
                      trigger={["hover"]}
                      placement="top"
                      overlay={popoverHoverFocus}
                    >
                      <div className="ps-2">
                        <img
                          src={manage_my_info_edit_logo}
                          alt="Edit"
                          width="18"
                        />
                      </div>
                    </OverlayTrigger>
                  )}
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.delivery_location?.address}
                </div>

                <div
                  className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.rental_days
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Number of Days
                  {invoiceDetails?.modified_field_flags?.rental_days && (
                    <OverlayTrigger
                      container={refpopup}
                      trigger={["hover"]}
                      placement="top"
                      overlay={popoverHoverFocus}
                    >
                      <div className="ps-2">
                        <img
                          src={manage_my_info_edit_logo}
                          alt="Edit"
                          width="18"
                        />
                      </div>
                    </OverlayTrigger>
                  )}
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.rental_days -
                    (invoiceDetails?.extended_rental_days || 0)}
                </div>

                {invoiceDetails?.extended_rental_days !== null &&
                  invoiceDetails?.extended_rental_days !== 0 && (
                    <>
                      <div className="col-md-12 invoice-div-head pt-3">
                        Extended Rental Days
                      </div>
                      <div className="col-md-12 invoice-div-data">
                        {invoiceDetails?.extended_rental_days}
                      </div>
                      <div className="col-md-12 invoice-div-head pt-3">
                        Total Rental Days
                      </div>
                      <div className="col-md-12 invoice-div-data">
                        {invoiceDetails?.rental_days}
                      </div>
                    </>
                  )}

                <div className="col-md-12 invoice-div-head pt-3">
                  Payment Method
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.payment_method}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  License Number
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_details?.drivingLicenseNumber}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  License Expiry Date
                </div>
                <div className="col-md-12 invoice-div-data">
                  {formatDate(
                    invoiceDetails?.customer_details?.licenceExpiryDate
                  )}
                </div>
              </div>
              <div className="col-md-6 border-start-invoice-details pt-4">
                <div className="col-md-12 invoice-div-head">Customer Name</div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_details?.firstname}&nbsp;
                  {invoiceDetails?.customer_details?.lastname}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  Customer email
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_details?.email}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  Customer Phone Number
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_phone_number}
                </div>
                <div>
                  <div
                    className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                      ?.delivery_start_time
                      ? "text-danger"
                      : ""
                      }`}
                  >
                    Slot Time
                    {invoiceDetails?.modified_field_flags
                      ?.delivery_start_time && (
                        <OverlayTrigger
                          container={refpopup}
                          trigger={["hover"]}
                          placement="top"
                          overlay={popoverHoverFocus}
                        >
                          <div className="ps-2">
                            <img
                              src={manage_my_info_edit_logo}
                              alt="Edit"
                              width="18"
                            />
                          </div>
                        </OverlayTrigger>
                      )}
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {formatTime(invoiceDetails?.delivery_start_time)} to{" "}
                    {formatTime(invoiceDetails?.delivery_end_time)}
                  </div>
                  <div className="col-md-12 invoice-div-head pt-3">
                    Delivery Time
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.delivery_date?.split("T")[1]?.substring(0, 5)}
                  </div>
                  {invoiceDetails?.delivered_by === "CUSTOMER" && (
                    <>
                      <div
                        className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                          ?.delivered_by
                          ? "text-danger"
                          : ""
                          }`}
                      >
                        Pickup By
                        {invoiceDetails?.modified_field_flags?.delivered_by && (
                          <OverlayTrigger
                            container={refpopup}
                            trigger={["hover"]}
                            placement="top"
                            overlay={popoverHoverFocus}
                          >
                            <div className="ps-2">
                              <img
                                src={manage_my_info_edit_logo}
                                alt="Edit"
                                width="18"
                              />
                            </div>
                          </OverlayTrigger>
                        )}
                      </div>
                      <div className="col-md-12 invoice-div-data">
                        {invoiceDetails?.delivered_by}
                      </div>
                    </>
                  )}
                  {invoiceDetails?.delivered_by === "KIRKOS_EXECUTIVE" && (
                    <>
                      <div
                        className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                          ?.delivered_by
                          ? "text-danger"
                          : ""
                          }`}
                      >
                        Delivery By
                        {invoiceDetails?.modified_field_flags?.delivered_by && (
                          <OverlayTrigger
                            container={refpopup}
                            trigger={["hover"]}
                            placement="top"
                            overlay={popoverHoverFocus}
                          >
                            <div className="ps-2">
                              <img
                                src={manage_my_info_edit_logo}
                                alt="Edit"
                                width="18"
                              />
                            </div>
                          </OverlayTrigger>
                        )}
                      </div>
                      <div className="col-md-12 invoice-div-data">
                        {invoiceDetails?.delivered_by}
                      </div>
                    </>
                  )}

                  {invoiceDetails &&
                    invoiceDetails?.insurance_order === true && (
                      <>
                        <div className="col-md-12 invoice-div-head pt-3">
                          Insurance Claim
                        </div>
                        <div className="col-md-12 invoice-div-data">
                          {invoiceDetails?.insurance_claim}
                        </div>
                        <div className="col-md-12 invoice-div-head pt-3">
                          Service Number
                        </div>
                        <div className="col-md-12 invoice-div-data">
                          {invoiceDetails?.erp_service_number}
                        </div>
                      </>
                    )}

                  <div className="col-md-12 invoice-div-head pt-3">
                    Free Upgrade By Merchant
                  </div>
                  {invoiceDetails?.free_upgrade_by_merchant === true ? (
                    <div className="col-md-12 invoice-div-data">Yes</div>
                  ) : (
                    <div className="col-md-12 invoice-div-data">No</div>
                  )}
                </div>

                <div
                  className={`col-md-12 invoice-div-head d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.babySeat ||
                    invoiceDetails?.latest_modified_field_flags
                      ?.additionalDriver ||
                    invoiceDetails?.latest_modified_field_flags?.cdw_amount ||
                    invoiceDetails?.latest_modified_field_flags
                      ?.windShieldProtection ||
                    invoiceDetails?.latest_modified_field_flags?.scdwAmount ||
                    invoiceDetails?.latest_modified_field_flags
                      ?.paiInsuranceAmount
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Additional Options
                  {(invoiceDetails?.modified_field_flags?.babySeat ||
                    invoiceDetails?.modified_field_flags?.additionalDriver ||
                    invoiceDetails?.modified_field_flags?.cdw_amount ||
                    invoiceDetails?.modified_field_flags
                      ?.windShieldProtection ||
                    invoiceDetails?.modified_field_flags?.scdwAmount ||
                    invoiceDetails?.modified_field_flags
                      ?.paiInsuranceAmount) && (
                      <OverlayTrigger
                        container={refpopup}
                        trigger={["hover"]}
                        placement="top"
                        overlay={popoverHoverFocus}
                      >
                        <div className="ps-2">
                          <img
                            src={manage_my_info_edit_logo}
                            alt="Edit"
                            width="18"
                          />
                        </div>
                      </OverlayTrigger>
                    )}
                </div>

                {/* <div className="col-md-12 invoice-div-head pt-3">
                  Additional Options
                </div> */}
                <div className="col-md-12 invoice-div-data">
                  <ul style={{ paddingLeft: '20px', marginBottom: '0', lineHeight: '1.8' }}>
                    {invoiceDetails?.products[0]?.babySeatAmount !== 0 &&
                      invoiceDetails?.products[0]?.babySeatAmount !== null && (
                        <li style={{ marginBottom: '8px' }}>Baby Seat</li>
                      )}{" "}
                    {invoiceDetails?.products[0]?.paiInsuranceAmount !== 0 &&
                      invoiceDetails?.products[0]?.paiInsuranceAmount !==
                      null && <li style={{ marginBottom: '8px' }}>PAI Insurance</li>}{" "}
                    {invoiceDetails?.products[0]?.windShieldProtection !== 0 &&
                      invoiceDetails?.products[0]?.windShieldProtection !==
                      null && <li style={{ marginBottom: '8px' }}>WindShield Protection</li>}{" "}
                    {invoiceDetails?.products[0]?.additionalDriverAmount !== 0 &&
                      invoiceDetails?.products[0]?.additionalDriverAmount !==
                      null && <li style={{ marginBottom: '8px' }}>Additional Driver</li>}{" "}
                    {invoiceDetails?.products[0]?.scdwAmount !== 0 &&
                      invoiceDetails?.products[0]?.scdwAmount !== null && (
                        <li style={{ marginBottom: '8px' }}>SCDW Insurance</li>
                      )}{" "}
                    {invoiceDetails?.products[0]?.cdwAmount !== 0 &&
                      invoiceDetails?.products[0]?.cdwAmount !== null && (
                        <li style={{ marginBottom: '8px' }}>CDW Insurance</li>
                      )}{" "}
                  </ul>
                </div>
              </div>
              {/* {invoiceDetails && invoiceDetails?.insurance_order === true && (
                <div className="col-md-12 pt-3">
                  <div className="row bg-delivery-details pb-3">
                    <div className="col-md-12 invoice-div-head pt-3 fs-6 invoice-text-yellow">
                      Insurance Details
                    </div>

                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance company
                      </div>
                      <div className="invoice-div-data">
                        {invoiceDetails?.insurance_company}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance Policy
                      </div>
                      <div className="invoice-div-data">
                        {invoiceDetails?.insurance_policy}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance Claim
                      </div>
                      <div className="invoice-div-data">
                        {invoiceDetails?.insurance_claim}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance Expiry Date
                      </div>
                      <div className="invoice-div-data">
                        {formatDate(invoiceDetails?.insurance_expiry_date)}
                      </div>
                    </div>

                    {invoiceDetails?.plate_number && (
                      <>
                        <div className="col-md-6">
                          <div className="invoice-div-head pt-3">
                            Customer Plate Number
                          </div>
                          <div className="invoice-div-data">
                            {invoiceDetails?.plate_number}
                          </div>
                        </div>
                      </>
                    )}
                    {invoiceDetails?.chassis_number && (
                      <>
                        <div className="col-md-6">
                          <div className=" invoice-div-head pt-3">
                            Customer Chassis Number
                          </div>
                          <div className=" invoice-div-data">
                            {invoiceDetails?.chassis_number}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )} */}
              {/* <div className="row pt-3">
                <div className="col-md-6">
                {commentMessage && commentMessage.length > 0 && (
                  <div className="col-md-12 invoice-div-head pt-3">
                    BackOffice Comments
                    {commentMessage.map((item: any, index: number) => (
                      <div key={index} className="pt-2">
                        {item.message}
                      </div>
                    ))}
                  </div>
                )} */}
              <div className="row pt-3">
                <div className="col-md-6">
                  {commentMessage && commentMessage.length > 0 && (
                    <div className="col-md-12 invoice-div-head pt-3">
                      BackOffice Comments
                      {commentMessage
                        .filter(
                          (item: any) =>
                            item?.orderStatus !== "MERCHANT_ORDER_ACCEPT" ||
                            item?.createdBy === "ROLE_MAKER"
                        )
                        .map((item: any, index: number) => (
                          <div
                            key={index}
                            className="pt-2 col-md-12 invoice-div-data"
                          >
                            {item?.message}
                          </div>
                        ))}
                    </div>
                  )}
                  {/* <div className="invoice-div-data style-word-brk">
                    {invoiceDetails?.order_comment}
                  </div> */}
                </div>
                <div className="col-md-6 border-start-invoice-details">
                  {commentMessage && commentMessage.length > 0 && (
                    <div className="col-md-12 invoice-div-head pt-3">
                      Merchant Comments
                      {commentMessage
                        .filter(
                          (item: any) =>
                            // item.orderStatus === "MERCHANT_ORDER_ACCEPT"
                            item?.createdBy === "ROLE_MERCHANT"
                        )
                        .map((item: any, index: number) => (
                          <div
                            key={index}
                            className="pt-2 col-md-12 invoice-div-data"
                          >
                            {item?.message}
                          </div>
                        ))}
                    </div>
                  )}
                  {/* <div className="invoice-div-data style-word-brk">
                    {invoiceDetails?.merchant_comment}
                  </div> */}
                </div>
              </div>

              <div className="col-md-6 pt-5 align-content-center">
                <div className="row">
                  {(() => {
                    const docTypes = [
                      {
                        keyPrefix: "EMIRITIES",
                        label: "EMIRATES",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "LICENSE",
                        label: "LICENSE",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "VisitVisa",
                        label: "VISA",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "Passport",
                        label: "Passport",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "EMIRITIES-ADD",
                        label: "EMIRATES-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                      {
                        keyPrefix: "LICENSE-ADD",
                        label: "LICENSE-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                      {
                        keyPrefix: "EMIRITIES1-ADD",
                        label: "EMIRATES-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                      {
                        keyPrefix: "LICENSE1-ADD",
                        label: "LICENSE1-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                    ];

                    return docTypes.map(({ keyPrefix, label, object }) => {
                      if (!object) return null;

                      return Object.keys(object)
                        .filter((key) => key.startsWith(keyPrefix))
                        .map((key) => (
                          <div
                            key={key}
                            id={`${key}_container`}
                            className="col-md-6 mb-2"
                          >
                            <p>{label}: </p>

                            <img
                              id={`${key}_IMAGE`}
                              src={object[key]}
                              style={{ width: 75, height: 75 }}
                              alt={`${key} document`}
                            />

                            <a
                              className="download-img"
                              id={`${key}DownloadLink`}
                              href={object[key]}
                              title={`Download ${key} PDF`}
                              style={{ display: "none" }}
                            >
                              Download {key} PDF
                            </a>
                          </div>
                        ));
                    });
                  })()}
                </div>
              </div>
              <div className="col-md-6 pt-5">
                <div className="card invoice-card-inner">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-1  text-center">
                        <img
                          src={dashboard_invoice_order_history}
                          height={"16px"}
                          alt=""
                        />
                      </div>
                      <div className="col invoice-text-yellow">
                        Order History
                      </div>
                    </div>
                    <div className="col-md-11 pt-3">
                      <div className="d-flex ">
                        <div className="col-1  text-center">
                          <img
                            src={dashboard_invoice_order_date}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div className="invoice-div-head">
                            Purchase order Date
                          </div>
                          <div className="invoice-inner-card-text">
                            {formatDate(invoiceDetails?.createdAt)}{" "}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div>
                      <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={dashboard_invoice_green_tick}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div className=" invoice-div-head">Status</div>
                          <div className=" invoice-text-green">
                            {invoiceDetails?.orderStatus}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div>
                      <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={merchant_dashboard_location_icon}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div
                            className={`col-md-12 invoice-div-head d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                              ?.delivery_location ||
                              invoiceDetails?.latest_modified_field_flags
                                ?.delivery_date
                              ? "text-danger"
                              : ""
                              }`}
                          >
                            Delivery Date & Location
                            {(invoiceDetails?.modified_field_flags
                              ?.delivery_location ||
                              invoiceDetails?.modified_field_flags
                                ?.delivery_date) && (
                                <OverlayTrigger
                                  container={refpopup}
                                  trigger={["hover"]}
                                  placement="top"
                                  overlay={popoverHoverFocus}
                                >
                                  <div className="ps-2">
                                    <img
                                      src={manage_my_info_edit_logo}
                                      alt="Edit"
                                      width="18"
                                    />
                                  </div>
                                </OverlayTrigger>
                              )}
                          </div>
                          <div className="invoice-inner-card-text">
                            {formatDate(invoiceDetails?.delivery_date)} |
                            {invoiceDetails?.delivery_location?.address}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-11 pt-3">
                        {invoiceDetails?.order_reassign_history_response?.some(
                          (history: any) => history?.delivery_date
                        ) &&
                          invoiceDetails?.order_reassign_history_response?.some(
                            (history: any) =>
                              history?.previous_delivery_date !==
                              history?.delivery_date
                          ) && (
                            <>
                              <div className="d-flex">
                                <div className="col-1 text-center">
                                  <img
                                    src={dashboard_invoice_order_date}
                                    height={"18px"}
                                    alt=""
                                  />
                                </div>
                                <div className="col">
                                  <div className="invoice-div-head">
                                    Initial Delivery Date
                                  </div>
                                  <div className="invoice-inner-card-text">
                                    {formatDate(
                                      invoiceDetails?.order_reassign_history_response?.find(
                                        (history: any) =>
                                          history?.previous_delivery_date &&
                                          history?.previous_delivery_date !==
                                          history?.delivery_date
                                      )?.previous_delivery_date || ""
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex ps-2">
                                <div className="col-1 text-center hor_line"></div>
                              </div>

                              {invoiceDetails?.order_reassign_history_response?.map(
                                (history: any, index: number) =>
                                  history?.delivery_date &&
                                  history?.previous_delivery_date !==
                                  history?.delivery_date && (
                                    <div key={index}>
                                      <div className="d-flex pt-2">
                                        <div className="col-1 text-center">
                                          <img
                                            src={dashboard_invoice_order_date}
                                            height={"18px"}
                                            alt=""
                                          />
                                        </div>
                                        <div className="col">
                                          <div className="invoice-div-head">
                                            Updated Delivery Date
                                          </div>
                                          <div className="invoice-inner-card-text">
                                            {formatDate(history?.delivery_date)}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="d-flex ps-2">
                                        <div className="col-1 text-center hor_line"></div>
                                      </div>
                                    </div>
                                  )
                              )}
                            </>
                          )}
                      </div>

                      <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div>
                      <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={merchant_dashboard_location_icon}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div
                            className={`col-md-12 invoice-div-head d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                              ?.recollection_location ||
                              invoiceDetails?.latest_modified_field_flags
                                ?.recollection_date
                              ? "text-danger"
                              : ""
                              }`}
                          >
                            Recollection Date & Location
                            {(invoiceDetails?.modified_field_flags
                              ?.recollection_location ||
                              invoiceDetails?.modified_field_flags
                                ?.recollection_date) && (
                                <OverlayTrigger
                                  container={refpopup}
                                  trigger={["hover"]}
                                  placement="top"
                                  overlay={popoverHoverFocus}
                                >
                                  <div className="ps-2">
                                    <img
                                      src={manage_my_info_edit_logo}
                                      alt="Edit"
                                      width="18"
                                    />
                                  </div>
                                </OverlayTrigger>
                              )}
                          </div>
                          <div className="invoice-inner-card-text">
                            {formatDate(invoiceDetails?.recollection_date)} |{" "}
                            {invoiceDetails?.recollection_location?.address}
                          </div>
                        </div>
                      </div>
                      {/* <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div> */}
                      {/* <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={dashboard_invoice_payment_done}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div className=" invoice-text-green">
                            {invoiceDetails?.payment_status}
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 pt-5">
              <div className="card invoice-card-inner-mechant">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6 pt-3">
                      <label className="invoice-text-yellow">
                        Plate Number
                      </label>
                      <span className="merchantStar">*</span>
                      <CustomInput
                        inputName="plate_number"
                        inputType="plate_number"
                        className="merchant-input-style-create-product"
                        placeholder=""
                        editable={true}
                        //onInputChange={(value: string) => {}}
                        onInputChange={handlePlateNumberChange}
                        control={control}
                        rules={AuthRules.registration_number}
                      />
                      <div>
                        {plateNumberError && (
                          <div
                            className="invoice ms-4"
                            style={{ color: "red" }}
                          >
                            {plateNumberError}
                          </div>
                        )}
                      </div>
                    </div>
                    {invoiceDetails?.delivered_by !== "CUSTOMER" && (
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Delivery Executive Name
                        </label>

                        <span className="merchantStar">*</span>
                        <CustomInput
                          inputName="deliveryboyName"
                          inputType="deliveryboyName"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleDeliveryBoyNameChange}
                          control={control}
                        />
                      </div>
                    )}
                    <div className="col-6 pt-3">
                      <label className="invoice-text-yellow">
                        Delivered Fuel
                      </label>
                      <span className="merchantStar">*</span>
                      <FuelBar>
                        {[...Array(8)].map((_, index) => (
                          <div
                            key={index}
                            className={`fuel-segment ${Number(deliveredFuel) > index ? "active" : ""
                              }`}
                            onClick={() =>
                              handleFuelNumberChange((index + 1).toString())
                            }
                          />
                        ))}
                        <span className="fuel-label">
                          {deliveredFuel ? `${deliveredFuel}/8` : "0/8"}
                        </span>
                      </FuelBar>
                    </div>
                    <div className="col-6 pt-3">
                      <label className="invoice-text-yellow">
                        Delivered Mileage
                      </label>

                      <span className="merchantStar">*</span>
                      <CustomInput
                        inputName="deliveredMileage"
                        inputType="deliveredMileage"
                        className="merchant-input-style-create-product"
                        placeholder=""
                        editable={true}
                        //onInputChange={(value: string) => {}}
                        onInputChange={handleMileageNumberChange}
                        control={control}
                      />
                    </div>
                    {invoiceDetails?.delivered_by !== "CUSTOMER" && (
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Delivery Executive Phone No
                        </label>
                        <span className="merchantStar">*</span>
                        <div className="inputContainerStyle text-end">
                          <span className="merchantorders_new_country_codestyle ">
                            +971
                          </span>
                          <CustomInput
                            inputName="phoneNo"
                            inputType="text"
                            className="merchant-input-style-create-product"
                            placeholder=""
                            maxLength={9}
                            editable={true}
                            //onInputChange={(value: string) => {}}
                            onInputChange={handleDeliveryBoyNumberChange}
                            control={control}
                            rules={rules.AuthRules.phone_number}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-md-6 pt-3 date-component-rewrite">
                      <div>
                        <label className="invoice-text-yellow">
                          Delivery Date and Time
                        </label>
                        <span className="merchantStar">*</span>
                      </div>
                      <div className="input-date-container">
                        <input
                          type="datetime-local"
                          id="datetime"
                          value={dateTime}
                          onChange={handleDateTimeChange}
                          min={minDateTime}
                          className="merchant-input-style-create-product"
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-6 pt-3 date-component-rewrite">
                      <TimePicker
                        value={null}
                        label="DeliveryTime"
                        onChange={handleDropOffTimeChange}
                      />
                    </div> */}

                    <div className="col-12 invoice-div-data text-center pt-3">
                      Documents Upload
                    </div>
                    <div className="col-md-6 pt-3 ">
                      <label className="invoice-text-yellow">
                        {" "}
                        VDR Upload{" "}
                      </label>
                      <span className="merchantStar">*</span>
                      &nbsp;
                      <button
                        className="btn-custom-upload"
                        // onClick={openFileInput}
                        onClick={() => openFileInput("vdr")}
                      >
                        Browse File
                      </button>
                      <input
                        type="file"
                        //ref={fileInputRef}
                        ref={vdrInputRef}
                        style={{ display: "none" }}
                        multiple
                        // onChange={(e) => handleImageUpload(e.target.files)}
                        onChange={(e) =>
                          handleImageUpload(e.target.files, "vdr")
                        }
                      />
                      <table className="img-managemycar-table">
                        {vdrUploadedImages.map((image, index) => (
                          <tr key={index}>
                            <td>
                              <div className="p-1">
                                {image.endsWith(".pdf") ? (
                                  <>
                                    <img
                                      src={pdf}
                                      alt={`Document ${index + 1}`}
                                      className="img-div-custom"
                                    />
                                    <a
                                      href={image}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="p-2"
                                    >
                                      PDF
                                    </a>
                                  </>
                                ) : (
                                  <img
                                    src={image}
                                    alt={`Document ${index + 1}`}
                                    className="img-div-custom"
                                  />
                                )}
                              </div>
                            </td>
                            <td>
                              <span
                                className="text-danger cursor-pointer ms-2"
                                // onClick={() => handleUploadDeleteImage(index)}
                                onClick={() =>
                                  handleUploadDeleteImage(index, "vdr")
                                }
                              >
                                <Trash />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </table>
                    </div>

                    <div className="col-md-6 pt-3">
                      <label className="invoice-text-yellow">
                        Rental Agreement{" "}
                      </label>
                      <span className="merchantStar">*</span>
                      &nbsp;
                      <button
                        className="btn-custom-upload"
                        // onClick={openFileInput}
                        onClick={() => openFileInput("rentalAgreement")}
                      >
                        Browse File
                      </button>
                      <input
                        type="file"
                        //ref={fileInputRef}
                        ref={rentalAgreementInputRef}
                        style={{ display: "none" }}
                        multiple
                        //onChange={(e) => handleImageUpload(e.target.files)}
                        onChange={(e) =>
                          handleImageUpload(e.target.files, "rentalAgreement")
                        }
                      />
                      <table className="img-managemycar-table">
                        {rentalAgreementUploadedImages.map((file, index) => (
                          <tr key={index}>
                            <td>
                              <div className="p-1">
                                {file.endsWith(".pdf") ? (
                                  <>
                                    <img
                                      src={pdf}
                                      alt={`Document ${index + 1}`}
                                      className="img-div-custom"
                                    />
                                    <a
                                      href={file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="p-2"
                                    >
                                      PDF
                                    </a>
                                  </>
                                ) : (
                                  <img
                                    src={file}
                                    alt={`Document ${index + 1}`}
                                    className="img-div-custom"
                                  />
                                )}
                              </div>
                            </td>
                            <td>
                              <span
                                className="text-danger cursor-pointer ms-2"
                                onClick={() =>
                                  handleUploadDeleteImage(
                                    index,
                                    "rentalAgreement"
                                  )
                                }
                              >
                                <Trash />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </table>
                    </div>
                  </div>
                  <div className="col-12 pt-3">
                    <label className="invoice-text-yellow form-label">
                      Comments
                    </label>
                    <textarea
                      name="comments"
                      id="comments"
                      rows={5}
                      className="select-invoice-bg-black-textarea"
                      value={comments}
                      onChange={handleCommentsChange}
                    ></textarea>
                  </div>
                  <div className="col-12 px-3">
                    <div className="d-flex pt-3 justify-content-end invoice-text-yellow checkbox-order">
                      <CustomCheckBox
                        isChecked={isChecked}
                        onChange={handleCheckBoxChange}
                      />
                      <span className="upgrade-text">Upgrade by vendor</span>
                    </div>
                  </div>
                  {/* <div className=" text-end pb-3 pt-3">
                    <button
                      className="invoice-approve-btn px-3"
                      //disabled={!plateNumber || isButtonDisabled}
                      // onClick={() => mutation.mutate()}
                    >
                      Update
                    </button>
                  </div> */}
                  <div className="col-md-12 d-flex justify-content-end pt-5 pb-2">
                    <p className="info-text mt-1" id="license"></p>
                    <div className="invoice-details-btn-div text-end">
                      <button
                        className="invoice-approve-btn"
                        disabled={
                          !(
                            vdrUploaded &&
                            rentalAgreementUploaded &&
                            dateTime &&
                            plateNumber &&
                            (invoiceDetails?.delivered_by === "CUSTOMER" ||
                              (deliveryBoyPhone && deliveryBoyName))
                          )
                        }
                        onClick={handleSubmit}
                      >
                        {" "}
                        <img
                          src={dashboard_invoice_approve}
                          height={"14px"}
                          alt=""
                        />
                        &nbsp;APPROVE
                      </button>

                      <button
                        className="invoice-reject-btn"
                        onClick={handleReject}
                      >
                        {" "}
                        <span className="invoice-paid-failed-style">
                          {" "}
                          &#10006;
                        </span>
                        &nbsp; CANCEL
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        message="Oops! Something went wrong"
      />

      <ImagePopupModal
        isOpen={showImagePopupModal}
        //  onClose={onCloseImagePopupModal}
        src={imageSource}
        onClose={() => setShowImagePopupModal(false)}
        message={""}
      />

      <ConfirmationModal
        isOpen={showRejectConfirmationModal}
        onClose={() => setShowRejectConfirmationModal(false)}
        onConfirm={() => {
          handleRejection.mutate();
          setShowRejectConfirmationModal(false);
        }}
        message={rejectConfirmationMessage}
      />

      <ConfirmationModal
        isOpen={showAcceptConfirmationModal}
        onClose={() => setShowAcceptConfirmationModal(false)}
        onConfirm={() => {
          handleApproval.mutate();
          setShowAcceptConfirmationModal(false);
        }}
        message={acceptConfirmationMessage}
      />

      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
      /> */}
    </div>
  );
};

export default AcceptedorderDetails;
